import React from 'react';
import { Link } from 'react-router-dom';
import style from './ModuleEncart.css';
import * as icones from '../Icones'
import * as tools from '../Tools';
import isExternal from 'is-url-external';

const Fleche = ({ color }) => color == 'rouge' ? <icones.fleche /> : <icones.flecheRouge />


// IMAGE :
// largeur : 406px 
// hauteur : 305px
export default class Encart extends React.Component {
	icone(nomIcone) {
		return (
			<img
				src={nomIcone}
				style={{
					width: '120px',
					position: 'absolute',
					zIndex: '2',
					top: '50%',
					left: '50%' /* à 50%/50% du parent référent */,
					transform:
						'translate(-50%, -50%)' /* décalage de 50% de sa propre taille */
				}}
			/>
		);
	}

	checkFleche(color) {
		if (color == 'rouge') {
			return <icones.flecheRouge />
		} else {
			return <icones.fleche />
		}
	}

	content() {
		const { element } = this.props;
		return (
			<div
				className={"bg-white " + style.moduleEncart}
				style={{ border: '0px solid white', borderRadius: '20px' }}
			>
				{/* *** titre *** */}
				<h4 className="text-center pt-4 pb-4 ft-lato-light text-noir">
					{element.titre}
				</h4>
				{/* ******************** */}

				{/* *** image *** */}
				<div
					className={" " + style.encartContenuImage}
					style={{ position: 'relative' }}
				>
					<div className="align-self-center" style={{ margin: '0 auto' }}>
						{this.icone(element.iconSrc)}
					</div>
					<div
						className={" " + style.encartFleche}
						style={{
							zIndex: '5',
							position: 'absolute',
							marginTop: '-1px'
						}}
					/>
					<img
						src={`${tools.lienPhotos}/${element.imgSrc}`}
						className={"img-fluid " + style.encartImage}
						style={{ filter: 'brightness(70%)', zIndex: '1' }}
					/>
				</div>
				{/* ********************** */}

				<div style={{ zIndex: '10' }}>
					<h5
						className="pl-4 pr-4 pt-4 ft-alegreya-sans-medium"
						style={{ color: '#333' }}
					>
						{element.sousTitre}
					</h5>
					<div className="pl-4 pr-4 text-justify">
						<div
							className="ft-alegreya-sans-light pb-3 text-black"
							dangerouslySetInnerHTML={{ __html: element.contenu }}
						/>

						{/* Bloc Lire la suite */}
						{!element.lireLaSuiteHidden && (
							<div
								className="ml-1 mt-3 ft-lato-light pb-5"
								style={{ color: '#333', fontSize: '1.5em' }}
							>
								{this.checkFleche(this.props.element.theme || 'defaut')}
								&nbsp;&nbsp;{element.textLink || "Lire la suite"}
						</div>
						)}
						{/* ********************************** */}
					</div>
				</div>
			</div>
		)
	}

	render() {
		const { element } = this.props;
		return (
			<React.Fragment>
				<div className={"col-xl-4 col-md-6 mb-5 block"}>
					{isExternal(element.linkTo) ? (
						<a
							href={element.linkTo}
							target="_blank"
							to={element.linkTo}
							style={{ textDecoration: 'none' }}
						>
							{this.content()}
						</a>
					) : (
							<Link
								to={element.linkTo}
								className=""
								style={{ textDecoration: 'none' }}
							>
								{this.content()}
							</Link>
						)}
				</div>
			</React.Fragment>
		);
	}
}

